export const locale = {
    'EQUIPMENT': {
        'NONE': 'None',
        'AVAILABLE': 'Available',
        'UNAVAILABLE': 'Unavailable',

        'compressor': 'Compressor',
    },
}
